const formatGermanNumberMixin = {
  methods: {
    formatNumber(value) {
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    }
  }
}

export default formatGermanNumberMixin



// WEBPACK FOOTER //
// ./src/mixins/formatGermanNumber.js